// src/components/ThemeProvider.tsx
"use client";

import { useEffect } from "react";

export default function ThemeProvider() {
  useEffect(() => {
    // Usamos ruta relativa directa. Nginx enviará esto al backend.
    fetch('/api/configuracion', { cache: 'no-store' })
      .then((res) => {
        if (!res.ok) throw new Error("Error fetching config");
        return res.json();
      })
      .then((data) => {
        if (data && data.app_name) {
          if (data.primary_color) document.documentElement.style.setProperty("--color-primary", data.primary_color);
          if (data.secondary_color) document.documentElement.style.setProperty("--color-secondary", data.secondary_color);
          
          if (data.theme_layout) {
            document.documentElement.setAttribute("data-theme", data.theme_layout);
            localStorage.setItem("theme_layout", data.theme_layout);
          }

          document.title = `${data.app_name} | ${data.company_name}`;
        }
      })
      .catch((err) => console.error("Error al cargar configuración del tema:", err));
  }, []);

  return null;
}